import React from "react";
import { Helmet } from "react-helmet";
import CtaSection from "../Components/internal-pages/Cta_Section";
import LeftImgrightContent from "../Components/internal-pages/Leftimg_rightContent";
import RightimgLeftContent from "../Components/internal-pages/Rightimg_leftContent";
import NogapRightImage from "../Components/internal-pages/No_gap_right_Img";
import ClinetsLogoSlider from "../Components/home/ClientsLogoSlider";
import Whychooseus from "../Components/internal-pages/WhyChooseus";

const CompanyStore =()=>{

    const CTAContent = [
        {
          pageName: "Company Stores",
          paragraphitalic: "Simplify Shopping with Custom Company Stores",
          paragraphText:
            "eYantra makes it easy for businesses to build a unified, branded experience through Company Stores. Whether you’re looking to showcase your brand’s merchandise or streamline the distribution of essential office supplies, our tailored solutions make sure convenience, efficiency, and style – all in one place.",
          ContactFormName: "Employee Recognition",
        },
      ];
    
      const ContentImg = [
        {
          index: 0,
          leftImg: "./assests/images/company-store/Company_Brand store.png",
          leftHeading: "Brand Store ",
          leftSmallpara: "Your Brand, One Click Away ",
          leftParagraph:
            "Bring your brand to life with a fully customized online store that showcases your company’s identity. Our Brand Stores are tailored to reflect your unique style and offer your employees and partners easy access to high-quality branded merchandise.",
          leftRedirectUrl: "/company-store/brand-store",
        },
      ];
      const rightImgContent = [
        {
          index: 0,
          rightImg: "./assests/images/company-store/Company_Office supplies.png",
          rightHeading: "Office Supplies",
          rightSmallpara: "Streamline Essentials with Ease",
          rightParagraph:
            "Keep your workplace running smoothly with a dedicated store for all your office supply needs. Whether it’s day-to-day essentials or branded stationery, we provide a one-stop solution to make sure your team always has what they need.",
          rightRedirectUrl: "/company-store/office-supplies",
        },
      ];

    return(
        <>
            <Helmet>
                <title>eYantra Employee & Bulk Corporate Gifting</title>
                <meta name="description" content="eYantra specializes in bulk gifting, employee rewards, joining kits, and onboarding kits with personalized corporate gifts and welcome kits."/>
                <meta name="keywords" content="eyantra, corporate gifting, joining kits, rewards and recognitions, onboarding kits for employees, corporate gifts for employees, welcome kits,bulk gifting, employee gifts"/>
            </Helmet>

            <div className="p-0 m-2">
        <CtaSection data={CTAContent} />

        <LeftImgrightContent leftImgContent={ContentImg[0]} />
        <RightimgLeftContent data={rightImgContent[0]} />
        </div>

        <div className="my-5">
            <ClinetsLogoSlider/>
        </div>
        <Whychooseus/>
     


        </>
    )
}

export default CompanyStore;